module.exports = __webpack_public_path__ + "img/编码式.9010499f.png";